import React from "react";

export function TaskSectionEmptyState({ inlineCreator, showCreationPrompt }: Props) {
  return (
    <div className="px-4 py-6">
      {inlineCreator ? (
        <>
          {inlineCreator}
          <div className="hidden px-0 pt-2 text-center text-xs text-content-subtle sm:block">Нажми Enter, чтобы добавить. Задачи также можно перетаскивать сюда.</div>
        </>
      ) : showCreationPrompt ? (
        <div className="text-left text-sm text-content-subtle sm:text-center">
          <span className="sm:hidden">Нажми +, чтобы добавить задачу.</span>
          <span className="hidden sm:inline">Нажми + или клавишу c, чтобы добавить задачу, или перетащи задачу сюда.</span>
        </div>
      ) : (
        <div className="text-left text-sm text-content-subtle sm:text-center">Задач пока нет.</div>
      )}
    </div>
  );
}

type Props = {
  inlineCreator: React.ReactNode;
  showCreationPrompt: boolean;
};
